import {useState, useEffect} from "react";
import OGChefs from '../components/collections/og-chef-collection';
import Rarity from "../components/collections/rarity-panel";
import {gPageView} from "../google-analytics";
import MetaChefs from "../components/collections/meta-chefs-panel";
import IngredientsUtensilsRecipesPanel from "../components/collections/ingredients-utensils-recipes-collections";

function CollectionsPage() {
    useEffect(() => {
        gPageView('collections');
    }, );
    return (
        <div id="collections-page" className="">
            <div className="panel">
                <OGChefs background={true} />
                <IngredientsUtensilsRecipesPanel />
                <MetaChefs />
            </div>
        </div>
    );
}

export default CollectionsPage;